import React, { Component } from 'react'
import FilterGeography from './FilterGeography'
import FilterAreaOfInterest from './FilterAreaOfInterest'
import FilterContentType from './FilterContentType'
import FilterControls from './FilterControls'
import FilterIndustry from './FilterIndustry'
import FilterDate from './FilterDate'
import FilterTopics from './FilterTopics'

class SearchFilter extends Component {
  render() {
    return (
      <div className='searchFilter'>
        <FilterControls
          onApplySelection={this.props.onApplySelection}
          onResetSelection={this.props.onResetSelection}
          applyButtonId='ApplyButtonTop'
          resetButtonId='ResetButtonTop'
        />
        <div className='filterContent'>
          <FilterAreaOfInterest
            filterCategories={this.props.filterCategories.categories}
            selectedAois={this.props.selectedAois}
            onAoiChanged={this.props.onAoiChanged}
            ignoreAois={this.props.ignoreAois}
          />
          <FilterIndustry
            filterCategories={this.props.filterCategories.categories}
            selectedIndustryIds={this.props.selectedIndustryIds}
            onChange={this.props.onIndustryChanged}
          />
          <FilterGeography
            filterCategories={this.props.filterCategories.categories}
            selectedGeographyIds={this.props.selectedGeographyIds}
            onChange={this.props.onGeographyChanged}
          />
          <FilterTopics
            filterTopics={this.props.filterCategories.topics}
            selectedTopicIds={this.props.selectedTopicIds}
            onChange={this.props.onTopicChanged}
            clearSearchOnChange={this.props.clearSearchOnChange}
          />
          <FilterContentType
            filterContentTypes={this.props.filterCategories.contentTypes}
            selectedContentTypeIds={this.props.selectedContentTypeIds}
            onContentTypeChanged={this.props.onContentTypeChanged}
          />
          <FilterDate
            selectedDateFrom={this.props.selectedDateFrom}
            selectedDateTo={this.props.selectedDateTo}
            onDateRangeChanged={this.props.onDateRangeChanged}
          />
        </div>
        <FilterControls
          onApplySelection={this.props.onApplySelection}
          onResetSelection={this.props.onResetSelection}
          applyButtonId='ApplyButtonBottom'
          resetButtonId='ResetButtonBottom'
        />
      </div>
    )
  }
}

export default SearchFilter
